import React, { useEffect, useRef, useState } from 'react';
import OtpInput from 'react-otp-input';
import OtpSentIcon from '../../../OTPLoginBlock/Assets/SVG/otpSentIcon';
import TextInput from '../../../../Shared/TextInput/TextInput';
import '../AddressForm/addressForm.scss';
import './internetOtpCode.scss';

function maskPhoneDigits(phone) {
  const digits = String(phone ?? '').replace(/[^0-9]/g, '');
  if (digits.length < 10) {
    return digits;
  }
  return `${digits.slice(0, 3)}**${digits.slice(5)}`;
}

const InternetOtpCode = (props) => {
  const [code, setCode] = useState('');
  const [restrictCode, setRestrictCode] = useState('');
  const submittedCodeRef = useRef('');
  const isPaymentContactOtp = props.otpFlow === 'internetPaymentContactOtp';
  const restrictedCodeRequired = Boolean(props.restrictedCodeRequired);

  useEffect(() => {
    if (props.onSubmit) {
      props.validateOtp(code, restrictCode);
    }
  }, [props.onSubmit]);

  useEffect(() => {
    if (code.length === props.numberOfInputs && submittedCodeRef.current !== code) {
      if (restrictedCodeRequired && !restrictCode.trim()) {
        return;
      }
      submittedCodeRef.current = code;
      props.validateOtp(code, restrictCode.trim());
    }

    if (code.length < props.numberOfInputs) {
      submittedCodeRef.current = '';
    }
  }, [code, props.numberOfInputs]);

  useEffect(() => {
    if (props.errorMsg || props.restrictCodeError) {
      submittedCodeRef.current = '';
    }
  }, [props.errorMsg, props.restrictCodeError]);

  useEffect(() => {
    if ('OTPCredential' in window) {
      async function fetchOtp() {
        try {
          const otp = await navigator.credentials.get({
            otp: { transport: ['sms'] },
          });
          if (otp?.code) {
            setCode(otp.code);
          }
        } catch (err) {
          console.error('Error fetching OTP:', err);
        }
      }
      fetchOtp();
    }
  }, []);

  function handleResendClick(event, isVoice) {
    event.preventDefault();
    props.createOtp(isVoice);
  }

  const contactTarget = props.customerEmail
    ? props.customerEmail
    : maskPhoneDigits(props.otpPhone);

  return (
    <div className='internet-otp-code'>
      <div className='internet-otp-code__icon'>
        <OtpSentIcon />
      </div>
      {isPaymentContactOtp ? (
        <h1 className='internet-otp-code__headline internet-otp-code__headline--contact'>
          <span className='internet-otp-code__title'>שלחנו קוד אימות לאיש הקשר</span>
          {contactTarget ? (
            <span className='internet-otp-code__phone'>
              <bdi className='internet-otp-code__phone-number' dir='ltr'>
                {contactTarget}
              </bdi>
            </span>
          ) : null}
        </h1>
      ) : (
        <h1 className='internet-otp-code__headline'>
          <span className='internet-otp-code__title'>שלחנו קוד אימות </span>
          <span className='internet-otp-code__phone'>
            <span className='internet-otp-code__phone-prefix'>ל-</span>
            <bdi className='internet-otp-code__phone-number' dir='ltr'>
              {maskPhoneDigits(props.otpPhone)}
            </bdi>
          </span>
        </h1>
      )}
      <div className='internet-otp-code__input'>
        <OtpInput
          shouldAutoFocus={true}
          value={code}
          onChange={setCode}
          numInputs={props.numberOfInputs}
          isInputNum={true}
          separator={<span className='internet-otp-code__input-separator' />}
          inputStyle='internet-otp-code__input-box'
          containerStyle='internet-otp-code__input-row'
          renderInput={(inputProps, index) => (
            <input {...inputProps} key={index} autoComplete='one-time-code' />
          )}
        />
        {props.errorMsg ? <p className='internet-otp-code__error'>{props.errorMsg}</p> : null}
      </div>
      <div className='internet-otp-code__actions'>
        <a href='#' onClick={(e) => handleResendClick(e, false)}>
          שלחו את
          <br />
          הקוד שוב
        </a>
        <span className='internet-otp-code__actions-divider' aria-hidden='true' />
        <a href='#' onClick={(e) => handleResendClick(e, true)}>
          שלחו את הקוד
          <br />
          בהודעה קולית
        </a>
      </div>
      {restrictedCodeRequired ? (
        <div className='internet-otp-code__restrict address-sale-block'>
          <p className='internet-otp-code__restrict-label'>קוד זיהוי של איש הקשר</p>
          <div className='address-wrapper'>
            <div className='form-wrapper'>
              <div className='row-wrapper'>
                <TextInput
                  placeholder='קוד זיהוי'
                  value={restrictCode}
                  error={props.restrictCodeError}
                  id='restrictCode'
                  name='restrictCode'
                  type='text'
                  autoComplete='off'
                  required='required'
                  onChange={(e) => {
                    setRestrictCode(e.target.value);
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default InternetOtpCode;
